export default {
  "home.heading.default": "바로 통화하기",
  "home.heading.loading": "방 여는 중...",
  "home.heading.join": "들어갈 준비 됐나요?",
  "home.heading.joined": "입장 완료",
  "home.heading.pending": "호스트 기다리는 중",
  "home.body.default": "방 만들고, 링크 공유하고, 그냥 즐기세요.",
  "home.body.loading": "잠깐만요, 방 준비 중이에요.",
  "home.body.join": "캠이랑 마이크 확인하고 들어오세요.",
  "home.body.joined": "방이 열렸어요. 링크를 공유하거나 바로 시작해요.",
  "home.body.joined_in_room": "방에 들어왔어요 — 바로 시작하거나 링크를 공유해요.",
  "home.body.pending": "방이 잠겨있어요. 호스트가 열어줄 때까지 기다려주세요.",
  "home.cta.create": "방 만들기",
  "home.cta.join": "방 참여하기",
  "home.cta.enter": "입장하기",
  "home.cta.creating": "만드는 중...",
  "home.cta.joining": "들어가는 중...",
  "home.cta.opening": "여는 중...",
  "home.cta.pending": "승인 대기 중...",
  "home.copy_link": "링크 복사",
  "home.copied": "복사 완료!",
  "home.leave": "방 나가기",
  "home.back": "뒤로",
  "home.no_participants": "아직 아무도 없어요",
  "home.join_by_code": "초대 코드로 참여",
  "home.code_placeholder": "코드 입력",
  "home.name_placeholder": "이름",
  "home.people_one": "명",
  "home.people_other": "명",
  "home.marketing.invite.title": "방을 만들고,\n링크를 공유해요.",
  "home.marketing.invite.body": "터치 한 번으로 시작. 친구에게 링크만 보내면 누구나 들어올 수 있어요. 다운로드나 가입은 필요 없어요.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "원하는\n모습으로.",
  "home.marketing.look.body": "색보정, 소프트 포커스, 비네팅 — 아니면 얼굴을 아예 블러 처리할 수도 있어요. 내 카메라는 내 맘대로.",
  "home.marketing.host.title": "내 공간,\n내 맘대로.",
  "home.marketing.host.body": "방을 잠그거나, 마이크를 끄거나, 내보낼 수 있어요. 호스트가 모든 걸 관리해요.",
  "home.marketing.host.locked": "방 잠김",
  "home.marketing.host.waiting_to_join": "입장 대기 중",
  "home.marketing.host.wants_to_join": "님이 들어오고 싶어 해요",
  "home.marketing.anything.title": "진짜 아무 때나 쓰세요.",
  "home.marketing.anything.body": "스터디, 게임, 스탠드업 미팅, 같이 영상 볼 때 — 아니면 그냥 수다 떨 때도요.",
  "home.marketing.use_case.study_group": "📚 스터디",
  "home.marketing.use_case.game_night": "🎮 게임",
  "home.marketing.use_case.standup": "💼 스탠드업",
  "home.marketing.use_case.watch_party": "🍿 같이 보기",
  "home.marketing.use_case.catch_up": "☕ 수다",
  "home.marketing.use_case.jam_session": "🎸 잼 세션",
  "home.marketing.use_case.book_club": "📖 북클럽",
  "home.marketing.use_case.coworking": "💻 코워킹",
  "ended.heading": "통화 종료",
  "ended.left": "방에서 나왔어요.",
  "ended.room_ended": "{title} 방이 종료되었어요.",
  "ended.rejoin": "다시 들어가기",
  "ended.rejoining": "다시 들어가는 중...",
  "ended.home": "홈으로",
  "call.connecting": "연결 중",
  "call.waiting": "다른 사람 기다리는 중",
  "call.invite_code": "초대 코드",
  "call.audio_on": "오디오 켜짐",
  "call.muted": "음소거됨",
  "call.listening": "듣는 중",
  "call.audio_muted": "오디오 꺼짐",
  "call.speaking": "말하는 중",
  "call.you": "나",
  "call.you_label": "나",
  "call.you_suffix": "(나)",
  "call.chat_placeholder": "메시지 보내기...",
  "call.guest": "게스트",
  "call.room_fallback": "방",
  "call.focus_view": "포커스 뷰",
  "call.grid_view": "그리드 뷰",
  "call.swap_main_video": "메인 화면 바꾸기",
  "call.open_chat": "채팅 열기",
  "call.close_chat": "채팅 닫기",
  "call.leave_room": "방 나가기",
  "call.confirm_leave": "나갈까요?",
  "call.mic_on": "마이크 켜짐",
  "call.muted_label": "음소거됨",
  "call.camera_off": "카메라 꺼짐",
  "call.connect_failed": "연결 실패 — 인터넷을 확인하고 다시 시도해 주세요.",
  "call.camera_access_failed": "카메라에 접근할 수 없어요. 브라우저 권한을 확인해 주세요.",
  "call.recording_failed": "녹화를 시작할 수 없어요. 녹화 없이 통화를 계속합니다.",
  "call.initialize_failed": "통화 시작 중 문제가 생겼어요. 새로고침 후 다시 시도해 주세요.",
  "call.participants": "참여자",
  "call.open_participants": "참여자 목록 열기",
  "call.close_participants": "참여자 목록 닫기",
  "call.lock_room": "방 잠그기",
  "call.unlock_room": "방 잠금 해제",
  "call.locked": "잠김",
  "call.unlocked": "열림",
  "call.kick_member": "방에서 내보내기",
  "call.mute_member": "음소거",
  "call.unmute_member": "음소거 해제",
  "call.muted_by_host": "호스트가 음소거함",
  "call.waiting_to_join": "입장 대기 중",
  "call.approve": "승인",
  "call.deny": "거절",
  "call.profile_actions": "프로필 액션",
  "call.profile_in_room": "방에 있음",
  "call.profile_role_host": "호스트",
  "call.profile_role_you": "나",
  "call.profile_action_mute": "오디오 음소거",
  "call.profile_action_mute_meta": "나한테만 안 들려요 — 상대방은 몰라요",
  "call.profile_action_dm": "1:1 DM",
  "call.profile_action_dm_meta": "비밀 채팅 시작하기",
  "call.profile_action_view": "전체 프로필 보기",
  "call.profile_action_view_meta": "소개, 언어, 이전 세션",
  "call.profile_action_report": "신고하기",
  "call.profile_action_report_meta": "관리자에게 신고하기",
  "call.profile_sheet_close": "프로필 액션 닫기",
  "call.profile_open_actions": "프로필 액션 열기",
  "call.dm_title": "다이렉트 메시지",
  "call.dm_back": "액션으로 돌아가기",
  "call.dm_close": "DM 닫기",
  "call.dm_status_online": "온라인",
  "call.dm_in_room_with": "이 방에 있음",
  "call.dm_private_label": "비밀 채팅",
  "call.dm_private_meta": "둘만 볼 수 있는 메시지예요",
  "call.dm_input_placeholder": "비밀 메시지 보내기…",
  "call.dm_send": "전송",
  "call.dm_just_now": "방금",
  "call.dm_seen_just_now": "방금 읽음",
  "call.dm_typing": "{name}님이 입력 중…",
  "call.dm_minimize": "최소화",
  "call.dm_active_indicator": "대화 열기",
  "call.dm_unread_messages": "안 읽은 메시지 {count}개",
  "call.dm_toast_tap_to_open": "눌러서 열기",
  "call.dm_reopen_aria": "{name}님과 대화 다시 열기",
  "home.join_denied": "호스트가 입장을 거절했어요.",
  "home.error.room_not_found": "존재하지 않는 방 코드예요.",
  "home.error.profile_required": "계속하려면 프로필을 설정해 주세요.",
  "home.cta.set_up_profile": "프로필 설정하기",
  "home.profile_trigger_new": "눌러서 내 정보 추가하기",
  "home.profile_trigger_new_aria": "프로필 설정하기",
  "home.profile_trigger_edit_aria": "프로필 수정하기",
  "profile.eyebrow_new": "인사하기",
  "profile.eyebrow_edit": "내 프로필",
  "profile.title_new": "나만의 프로필 만들기.",
  "profile.title_edit": "프로필 수정",
  "profile.subtitle": "상대방이 나를 알 수 있게 간단한 정보를 입력해 주세요.",
  "profile.add_photo": "사진 추가",
  "profile.add_photo_soon": "사진 기능 준비 중",
  "profile.photo_empty": "눌러서 사진 추가",
  "profile.photo_ready": "사진 준비 완료",
  "profile.photo_save_first": "사진을 올리기 전에 프로필을 먼저 저장해 주세요",
  "profile.photo_crop_caption": "사진 자르기",
  "profile.photo_auto_caption": "드래그하고 확대해 보세요. 자동으로 저장돼요",
  "profile.photo_upload": "사진 업로드",
  "profile.photo_replace": "사진 변경",
  "profile.photo_remove": "사진 삭제",
  "profile.photo_cancel": "취소",
  "profile.photo_save": "사진 저장",
  "profile.photo_uploading": "사진 업로드 중…",
  "profile.photo_removing": "사진 삭제 중…",
  "profile.photo_choose_another": "다른 사진 선택",
  "profile.photo_drag_hint": "사진을 드래그해서 원 안에 맞춰주세요. 변경 사항은 자동 저장돼요.",
  "profile.photo_zoom": "확대",
  "profile.photo_horizontal": "가로 자르기",
  "profile.photo_vertical": "세로 자르기",
  "profile.name_label": "이름",
  "profile.name_placeholder": "뭐라고 부르면 될까요?",
  "profile.gender_label": "성별",
  "profile.gender.woman": "여성",
  "profile.gender.man": "남성",
  "profile.gender.unspecified": "선택 안 함",
  "profile.bio_label": "소개",
  "profile.bio_optional": "선택",
  "profile.bio_placeholder": "할 줄 아는 언어, 좋아하는 것, 뭐든 좋아요…",
  "profile.cta_new": "시작하기",
  "profile.cta_edit": "변경 사항 저장",
  "profile.saving": "저장 중…",
  "profile.close": "닫기",
  "profile.error.save_failed": "프로필을 저장하지 못했어요. 다시 시도해 주세요.",
  "profile.error.avatar_invalid_type": "PNG, JPEG, GIF, WebP 이미지를 선택해 주세요.",
  "profile.error.avatar_too_large": "5MB 이하의 이미지를 선택해 주세요.",
  "profile.error.avatar_too_small": "최소 96x96 픽셀 이상의 이미지를 선택해 주세요.",
  "profile.error.avatar_load_failed": "이미지를 읽을 수 없어요. 다른 파일을 시도해 주세요.",
  "profile.error.avatar_failed": "사진을 업로드하지 못했어요. 다시 시도해 주세요.",
  "profile.error.avatar_remove_failed": "사진을 삭제하지 못했어요. 다시 시도해 주세요.",
  "effects.title": "효과",
  "effects.soft": "소프트 포커스",
  "effects.vignette": "비네팅",
  "effects.face": "얼굴 블러",
  "effects.face_preview_only": "얼굴 블러 (미리보기 전용)",
  "effects.face_viewer_side": "얼굴 블러 (보는 사람 기준)",
  "effects.face_strength": "얼굴 블러 강도",
  "effects.grade.off": "끄기",
  "effects.grade.pop": "팝",
  "effects.grade.warm": "따뜻하게",
  "effects.grade.cool": "차갑게",
  "effects.grade.bw": "흑백",
  "camera.off": "카메라 꺼짐",
  "camera.check": "카메라 확인",
  "camera.retry": "카메라 다시 시도",
  "camera.ready": "카메라 준비 완료",
  "camera.idle.title": "카메라 켜기",
  "camera.idle.hint": "준비되면 브라우저에 권한을 요청할게요.",
  "camera.idle.button": "카메라 켜기",
  "camera.status.idle": "대기 중",
  "camera.status.off": "카메라 꺼짐",
  "camera.status.loading": "카메라 권한 요청 중...",
  "camera.status.denied": "브라우저에서 카메라 권한을 허용하고 다시 시도해 주세요.",
  "camera.status.error": "카메라 미리보기에 실패했어요. 다시 시도해 주세요.",
  "camera.status.unsupported": "이 브라우저에서는 카메라를 지원하지 않아요.",
  "camera.status.insecure": "카메라 접근은 HTTPS나 localhost 환경이 필요해요.",
  "camera.status.attach_failed": "카메라 미리보기를 시작할 수 없어요. 다시 시도해 주세요.",
  "camera.guest_name_placeholder": "게스트 이름",
  "camera.flip": "카메라 전환",
  "camera.save_name": "저장",
  "camera.edit_name": "이름 수정",
  "mic.on": "마이크 끄기",
  "mic.off": "마이크 켜기",
  "video.on": "카메라 끄기",
  "video.off": "카메라 켜기",
  "chat.title": "채팅",
  "chat.close": "채팅 닫기",
  "chat.loading": "불러오는 중...",
  "chat.load_earlier": "이전 메시지 불러오기",
  "chat.empty": "아직 메시지가 없어요",
  "chat.send_error": "메시지 전송 실패 — 다시 시도해 주세요.",
  "chat.input_placeholder": "메시지 입력...",
  "room.host": "호스트",
  "app.room_default_title": "방 만들기",
  "app.chat_connection_rejected": "채팅 연결 실패 — 새로고침해 보세요.",
  "app.copy_failed": "링크 복사 실패. 직접 선택해서 복사해 보세요.",
  "app.chat_not_connected": "아직 채팅이 연결되지 않았어요. 잠시 후 다시 시도해 주세요.",
  "footer.terms": "이용약관",
  "footer.copyright": "© 2026 Yano.AI"
}
